import React from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import {CalendarMonth} from "flowbite-react-icons/outline";

const DateTimePicker = ({label, formik, name, disabled = false}) => {

    const {errors, touched, values} = formik;
    const dateValue = values[name] ? new Date(values[name]) : null;

    return <div className="sl-text-left sl-width-100">
        <span className="sl-font sl-font-medium sl-text-sm sl-text-gray-700" dangerouslySetInnerHTML={{__html: label}}/>

        <div className={`sl-relative`}>
            <DatePicker
                format="MM/DD/YYYY HH:mm:ss"
                plugins={[ <TimePicker position="bottom" /> ]}
                value={dateValue}
                name={name}
                onChange={(value) => {
                    formik.setFieldValue(name, value ? value.format("YYYY-MM-DD HH:mm:ss") : "");
                }}
                containerStyle={{ width: "100%" }}
                style={{ color: "#101828", padding: "20px 10px", cursor: "pointer", width: "100%",
                    border: (touched[name] && errors[name]) ? '1px solid #FDA29B' : '' }}
            />

            <CalendarMonth
                className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer pointer-events-none sl-text-gray-900"
                size={24}
            />
        </div>

        {touched[name] && <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>}
    </div>

}

export default DateTimePicker;